// extracted by mini-css-extract-plugin
module.exports = {"folder-card__shared-folder":"folder-card_folder-card__shared-folder__p4W__"};